export default "__VITE_ASSET__964f511c__"